'use strict';

var Table = require('./Table');
var Column = require('./Column');
var ColumnGroup = require('./ColumnGroup');

Table.Column = Column;
Table.ColumnGroup = ColumnGroup;

module.exports = Table;


//////////////////
// WEBPACK FOOTER
// ./~/bee-table/build/index.js
// module id = 69
// module chunks = 0